module.exports = __webpack_public_path__ + "img/p3.7ee28d1b.png";